import { EpgEvent, StartPositionType, StreamInfo, StreamInfoType } from './StreamInfo';
import { convertLivePlayerTimes, epgAnalyticsProperties, getEpgMetaInfo } from './StreamInfoUtility';
import { StreamType } from '../../../api/models/Shared.types';
import { ReplayStreamInfo } from './ReplayStreamInfo';
import { Backend } from '../../../api/Backend';
import { IProgramV5, IProperty, IScheduleV5 } from '../../../api/models/AndromeTV.types';

export class LinearStreamInfo extends StreamInfo {
  _epgEvent: EpgEvent;
  _backend: Backend;
  private _canReplay: boolean;
  private _metaInfo: string;

  constructor(epgEvent: EpgEvent, backend: Backend, canReplay = false) {
    super();
    this._epgEvent = epgEvent;
    this._backend = backend;
    this._canReplay = canReplay;

    this._metaInfo = getEpgMetaInfo(backend, epgEvent.schedule?.published);
  }

  override get isAdult() {
    return this._epgEvent.program?.adult;
  }

  override get assetId() {
    return this._epgEvent.channel.channelId;
  }

  override get resourceId() {
    return this._epgEvent.channel.channelId;
  }

  override get type() {
    return StreamInfoType.LINEAR;
  }

  override get titleText() {
    return this._epgEvent.program?.text.title || '';
  }

  override get metaInfo() {
    return this._metaInfo;
  }

  override get channelName() {
    return this._epgEvent.channel.text.title || '';
  }

  override get streamType() {
    return StreamType.LINEAR;
  }

  override get startPositionTime() {
    return undefined;
  }

  get live() {
    return true;
  }

  override get schedule(): IScheduleV5 | undefined {
    return this._epgEvent.schedule;
  }

  override set schedule(schedule: IScheduleV5 | undefined) {
    this._metaInfo = getEpgMetaInfo(this._backend, schedule?.published);
    this._epgEvent.schedule = schedule;
  }

  override get channel() {
    return this._epgEvent.channel;
  }

  set program(program: IProgramV5) {
    this._epgEvent.program = program;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  override convertPlayTimes(pos: number, duration: number, isLive: boolean) {
    return convertLivePlayerTimes(pos, this._epgEvent.schedule?.published);
  }

  override get allowSeek(): boolean {
    return this._canReplay;
  }

  override get episode(): number {
    if (this._epgEvent.program) {
      return this._epgEvent.program.episodeNumber ?? 0;
    } else {
      return 0;
    }
  }

  override get season(): number {
    if (this._epgEvent.season) {
      return this._epgEvent.season.seasonNumber ?? 0;
    } else {
      return 0;
    }
  }

  override generateAnalyticsProperties(excluded: string[]): IProperty[] {
    const properties = super.generateAnalyticsProperties(excluded);
    properties.push(...epgAnalyticsProperties(this._epgEvent, excluded));
    return properties;
  }

  convertToReplay(): ReplayStreamInfo {
    return new ReplayStreamInfo(this._epgEvent, StartPositionType.BOOKMARK, this._backend, undefined);
  }
}
